import { Stack } from "@mui/material";
import { type FC } from "react";

import { EventPageSections } from "~/feature/event/constants";
import { RelatedEventsCarousel } from "~/feature/relatedEvents/components/RelatedEventsCarousel";
import type { IRelatedEvent } from "~/types/relatedEvent";

interface IRelatedEventsSectionProps {
  relatedEvents?: IRelatedEvent[];
}

export const RelatedEventsSection: FC<IRelatedEventsSectionProps> = ({
  relatedEvents,
}) => {
  if (!relatedEvents?.length) {
    return null;
  }

  return (
    <Stack component="section" id={EventPageSections.RelatedEvents}>
      <RelatedEventsCarousel header="Related events" events={relatedEvents} />
    </Stack>
  );
};
